// Los caracteres de control son exactamente lo que se quiere eliminar aqui: se
// cuelan al pegar texto y rompen el renderizado o el almacenamiento. La regla
// no-control-regex existe para los que aparecen por accidente, no para este uso.
// eslint-disable-next-line no-control-regex
const CARACTERES_CONTROL = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;
const DELIMITADORES_HTML = /[<>]/g;

function quitarEtiquetasHtml(valor) {
  let resultado = "";
  let dentroDeEtiqueta = false;
  for (const caracter of valor) {
    if (caracter === "<") {
      dentroDeEtiqueta = true;
      continue;
    }
    if (caracter === ">") {
      dentroDeEtiqueta = false;
      continue;
    }
    if (!dentroDeEtiqueta) resultado += caracter;
  }
  return resultado;
}

export function sanitizarTexto(valor, { recortar = true } = {}) {
  if (typeof valor !== "string") return "";
  const limpio = quitarEtiquetasHtml(valor.normalize("NFKC"))
    .replace(CARACTERES_CONTROL, "")
    .replace(DELIMITADORES_HTML, "");
  return recortar ? limpio.trim() : limpio;
}

export function sanitizarEmail(valor) {
  return sanitizarTexto(valor).toLowerCase();
}
